export const HostAuth = () => {
  return (
    <>
      <h1 id='about-host-authentication'>About Host Authentication</h1>
      <p>When you run the Playcast Host, you are making your computer accessible to anyone who has the link you share.</p>
      <p>
        We do a number of things to protect you, recently improved in builds after around v0.10.60. For example, you get a unique host ID
        every time you start streaming from the host. We use a SHA256 secured unique ID as the host ID, so it is unguessable and will never
        get used twice.
      </p>
      <p>
        A player receiving your unique stream link gets a validation token submitted when he tries to connect. If this is not validated, his
        connection is rejected. This validation token is also unique and used only once.
      </p>
      <h2 id='recommendation-on-windows-accounts'>Recommendation on Windows Accounts</h2>
      <p>
        Especially if you&#39;re going to share access unattended, we recommend you create a guest account, or at least a separate standard
        account. Windows provides amazing security between accounts on the same computer, so we suggest you make use of it and only allow
        access to the files and software you&#39;re okay with sharing with others. We don&#39;t impose any authentication requirements on
        that.
      </p>
      <h2 id='the-danger'>The Danger</h2>
      <p>
        Despite all of this protection, if you inadvertently share this link with someone while your computer is running on Windows as an
        administrator (which is very common as the default way most people set up a home computer), and you turn on mouse and keyboard
        input, the remote user could maliciously take over your computer.
      </p>
      <h2 id='so-authentication'>So, Authentication</h2>
      <p>
        To help mitigate this danger further, as minimal as it is, by default we require you, as the host, to create an account and
        authenticate before starting streaming. We also require the player connecting to register and authenticate so there is a record of
        who exactly is using your computer.
      </p>
      <p>
        In this first release of the new authentication system, you can only remote connect to your computer when it is in admin mode when
        that remote player has logged in with the same account - that is, only you, the host, can remote connect.
      </p>
      <p>
        In the near future, we will provide a way for you to allow other authenticated users to be whitelisted to connect to your computer
        in admin mode. That takes some new user interface work that&#39;s underway now. We have already constructed the underlying
        infrastructure to support it. When we add that, we will even allow you to require whitelisted users on standard or guest accounts so
        you can impose stricter requirements on your players if you want.
      </p>
      <h2 id='but-freedom-'>But Freedom!</h2>
      <p>
        One of our underlying priniciples is that you don&#39;t have to do all this registration stuff if you don&#39;t want to. To that
        end, we have included a toggle with the label &quot;Don&#39;t require auth&quot; when you run the host and are in admin mode. If you
        know what you&#39;re doing, you can turn that on and then share your stream exactly as in earlier versions, accepting the risks.
      </p>
      <h2 id='final-caution'>Final Caution</h2>
      <p>
        Don&#39;t start the stream on a computer in admin mode, opt out of requiring auth, share your URL publicly (like in a tweet on X,)
        turn on all mouse and keyboard access by default, and then leave it running for days. That is simply asking for trouble - it&#39;s
        like leaving your debit card on the table at Starbucks along with a note with your PIN on it.
      </p>
      <p>
        Some bad person is going to go mess with your stuff and you&#39;ll have no idea what he might do. Probably summon a Great Old One in
        your house over a remote connection. Or worse.
      </p>
    </>
  );
};
